import { render } from "./AlertDialog2.vue?vue&type=template&id=2badafc4&scoped=true"
import script from "./AlertDialog2.vue?vue&type=script&lang=js"
export * from "./AlertDialog2.vue?vue&type=script&lang=js"

import "./AlertDialog2.vue?vue&type=style&index=0&id=2badafc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2badafc4"],['__file',"src/components/AlertDialog2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2badafc4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2badafc4', __exports__)) {
    api.reload('2badafc4', __exports__)
  }
  
  module.hot.accept("./AlertDialog2.vue?vue&type=template&id=2badafc4&scoped=true", () => {
    api.rerender('2badafc4', render)
  })

}


export default __exports__